import noop from '@gaia/util/noop/action'
import index from './action/index'
import licenceDetail from './action/licence/detail'
import licenceInsert from './action/licence/insert'
import measurementIndex from './action/measurement/index'
import measurementCreate from './action/measurement/create'
import measurementDetail from './action/measurement/detail'
import measurementSubmit from './action/measurement/submit'
import sensorDetail from './action/sensor/detail'
import report from './action/report'
import connect from './action/connect'

export default {
  index,
  teaser: noop,

  // measurement
  measurementIndex,
  measurementCreate,
  measurementSubmit,
  measurementDetail,

  validateRedirect: noop,

  // report
  reportGenerate: noop,
  report,

  // sensor
  sensorIndex: noop,
  sensorDetail,
  sensorUsage: noop,

  // pairing
  pairingCreate: noop,
  pairingSubmit: noop,

  // licence
  licenceIndex: noop,
  licenceCreate: noop,
  licenceDetail,
  licenceInsert,
  licenceSubmit: noop,

  serviceItems: noop,

  connect,
  contacts: noop,
}
